import { useAuth } from 'hooks'
import { Navigate, Outlet } from 'react-router'

// TODO: Improve this logic when the authContext is created
const ProtectedRoute = () => {
  const { user, isLoggedIn } = useAuth()

  if (!user || !isLoggedIn()) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}

export default ProtectedRoute
